import React from "react";

const Notification = ({ details }) => (
  <a className="dropdown-item d-flex align-items-center" href="/#">
    <div className="mr-3">
      <div className="icon-circle bg-primary">
        <i className={`${details.icon} text-white`}></i>
      </div>
    </div>
    <div>
      <div className="small">{details.date}</div>
      <span className={details.read ? "" : "font-weight-bold"}>{details.body}</span>
    </div>
  </a>
);

export default Notification;
